<div class="flex flex-col gap-4 mt-10">
  <div class="w-full h-[calc(100vh-185px)] flex flex-col gap-4">
    <div class="flex flex-col gap-4 justify-between">
      <div class="w-full flex flex-col gap-7">
        <qaroni-account-avatar
          [image]="account?.image ?? null"
          [name]="account?.name ?? ''"
          [id]="account?.id ?? null" />

        <div class="w-full text-center flex flex-col justify-center gap-1">
          <span
            class="text-qaroni-text-primary text-lg leading-7 font-medium"
            >{{ account?.name ?? '' }}</span
          >
          <span
            class="text-qaroni-text-secondary text-base leading-6 font-normal"
            >{{ account?.identifier ?? '' }}</span
          >
        </div>

        <div class="w-full text-center">
          <button
            (click)="changeViewEdit(ProfileViewEnum.PASSWORD)"
            class="qaroni-link">
            Restablecer contraseña
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full mx-auto text-center">
    <button
      (click)="changeViewEdit(ProfileViewEnum.EDIT)"
      class="qaroni-btn qaroni-btn-black-outline">
      Editar perfil
    </button>
  </div>
</div>
